import * as T from '../../../store/types'
import { get, post } from 'src/helpers/api'
import { api } from '../api'
import { SET_QUEUE_REQUEST_RESPONSE } from '../../../store/types'

export const getCWIncomeStatementAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.cwIncomeStatement, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getYearlyIncomeReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.yearlyIncomeReport, query).then(response => {
      commit(T.SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getStockistCommissionStatementAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistCommission, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getCWBonusReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.cwBonusReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getBonusAdjustmentListAction = async ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberBonusManualAdjustment + query).then(response => {
      const json = response.data
      commit(T.SET_BONUS_ADJUSTMENT_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getBonusAdjustmentData = async ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberBonusManualAdjustment + '/' + query).then(response => {
      const json = response.data
      commit(T.SET_BONUS_DATA, json)
      resolve(json)
    })
  })
}

export const createBonusAdjustmentAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    post(api.memberBonusManualAdjustment, query)
      .then(response => {
        const json = response.data
        commit(T.SET_BONUS_DATA, json)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const downloadBonusesBulkUploadTemplateFileAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    get(api.downloadManualAdjustmentTemplate, payload).then(response => {
      resolve(response.data)
    })
  })
}
